import { ActivityReducers } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { removeDataHolder } from "../actions";

export const removeDataHolderReducer: ActivityReducers.DataReducer = {
	reduce(dataHolders, action) {
		if (!removeDataHolder.match(action)) {
			return dataHolders;
		}

		return [
			{
				descriptor: action.payload.defaultDescriptor,
				dirty: false,
				loadingState: "missing",
				savingState: "saved",
				slices: {}
			}
		];
	}
};
